/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var elements = document.getElementsByClassName( "section--half" );
elements = Array.from( elements ) ;
elements.forEach(x => x.parentNode.classList.add('js-section--half'));



$(function() {

//Lang Shopでは置き換えられないプロダクトタイプの翻訳
const translation = [
{ "ko" : "캠핑용품", "ja" : "キャンプ用品", "en" : "Camping Equipment"},
{ "ko" : "의약품/건강기능", "ja" : "医薬品/健康食品", "en" : "Pharmaceuticals/Health Foods"},
{ "ko" : "일본헤어/화장품", "ja" : "ヘアケア/スキンケア/化粧品", "en" : "Hair Care/Skin Care/Cosmetics"},
{ "ko" : "일본식품/간식", "ja" : "食品", "en" : "Foods"},
{ "ko" : "일본주방용품", "ja" : "キッチン用品", "en" : "Kitchen Supplies"},
{ "ko" : "일본생활가전/용품", "ja" : "家電/生活用品", "en" : "Home Appliances/Household Goods"},
{ "ko" : "일본의류/속옷/스타킹", "ja" : "衣類/下着/ストッキング", "en" : "Clothing/Underwear/Stockings"},
{ "ko" : "일본술", "ja" : "日本酒", "en" : "Sake"},
{ "ko" : "한국화장품", "ja" : "韓国化粧品", "en" : "Korean Cosmetics"},
];

  var $dir = location.href.split("/");
  var $lang = $dir[3];
  
  if($lang == 'ja'){
     translateJa("#search-product-type option"); //検索バーのカテゴリ一覧ドロップダウン
     translateJa(".collection__filter-checkbox label"); //絞り込み表示の商品タイプ一覧
     translateJa(".collection__title");
  }else if($lang == 'en'){
     translateEn("#search-product-type option"); //検索バーのカテゴリ一覧ドロップダウン
     translateEn(".collection__filter-checkbox label"); //絞り込み表示の商品タイプ一覧
     translateEn(".collection__title");
  }

function translateJa(target){
   for(let i=0; i<translation.length; i++){
    $(target).each(function(){ 
        let text = $(this).text();
        if(text.includes(translation[i].ko)){
          const translated = text.replace(translation[i].ko, translation[i].ja);
          $(this).text(translated);
       }
    });
  }
}

function translateEn(target){
   for(let i=0; i<translation.length; i++){
    $(target).each(function(){ 
        let text = $(this).text();
        if(text.includes(translation[i].ko)){
          const translated = text.replace(translation[i].ko, translation[i].en);
          $(this).text(translated);
       }
    });
  }
}

  /*
//price小数点以下切捨て
  $(".money").each(function(){
    const money = $(this).text();
    let moneyNum = money.replace(/[^0-9\.]/g, ''); //数字だけ抜きだし
    let moneyFloor = parseInt(moneyNum, 10);

    moneyNum = Number(moneyNum).toFixed(2);
    moneyNum = comma(moneyNum);
    moneyFloor =  comma(moneyFloor);
    const moneyNew = money.replace(moneyNum, moneyFloor);
    
    $(this).text(moneyNew);

    
    console.log("moneyは"+money);
    console.log("moneyNumは"+moneyNum);
    console.log("moneyFloorは"+moneyFloor);
    console.log("moneyNewは"+moneyNew);
    
  });
  */

}); //function();

/*
function comma(num) {
    var s = String(num).split('.');
    var ret = String(s[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    if (s.length > 1) {
        ret += '.' + s[1];
    }
    return ret;
}
*/